import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { supabaseStore } from '~/lib/stores/supabase';
import { workbenchStore } from '~/lib/stores/workbench';

export const PromptOverlay = memo(() => {
  const supabaseRequiresAction = useStore(supabaseStore.promptDisabled);
  const connectingToSupabase = useStore(supabaseStore.connecting);
  const applyingDatabaseMigrations = useStore(supabaseStore.applyingMigrations);
  const hasDatabaseMigrations = useStore(supabaseStore.hasMigrations);
  const isSupabaseConfigured = useStore(supabaseStore.isConfigured);
  const isStreaming = useStore(workbenchStore.isStreaming);

  const showOverlay = !isStreaming && supabaseRequiresAction;

  const getMessage = () => {
    if (supabaseRequiresAction) {
      const baseMessage = 'The prompt is currently disabled until ';

      if (applyingDatabaseMigrations) {
        return baseMessage + 'all the database changes have been applied.';
      } else if (isSupabaseConfigured && hasDatabaseMigrations) {
        return baseMessage + 'you either approve or discard the pending database changes.';
      } else if (connectingToSupabase) {
        return baseMessage + 'your project is fully connected to Supabase.';
      } else if (!isSupabaseConfigured) {
        return baseMessage + 'you connect your project to Supabase (or discard this message).';
      }
    }

    return 'The prompt is currently disabled.';
  };

  return (
    showOverlay && (
      <div className="absolute rounded-lg inset-1 bg-bolt-elements-prompt-background z-2">
        <div className="p-6 text-bolt-elements-textSecondary flex flex-col gap-1.5 text-sm">
          <h2 className="flex items-center gap-1.5 font-semibold">
            <div className="i-ph:info-bold size-4.5 shrink-0" />
            Prompt disabled
          </h2>
          {getMessage()}
        </div>
      </div>
    )
  );
});
